// extracted by mini-css-extract-plugin
module.exports = {"infoCopy":"velocity-page_infoCopy__Fm5bP"};